import {cs}          from "../chain-services";
import {fragments}   from "../fragments";
import {OnMounted}   from "../on-mounted";
import {OnUnmounted} from "../on-unmounted";
import {Static}      from "../static";
import {Static2}     from "../static-2";

/**
 * NOTE: parentNode need to have "position: relative;", node has no siblings, no margin top, bottom
 */
export const ForceSticky = ({next}) => cs(
    ["domRef", (_, next) => Static2({next})],
    ["cleanups", (_, next) => Static({initValue: [], next})],
    ({cleanups}, next) => fragments(
        next(),
        OnUnmounted({
            action: () => cleanups.forEach(v=>v()),
        }),
    ),
    ({domRef, cleanups}, next) => fragments(
        next(),
        OnMounted({
            action: () => {
                const dom = domRef.get();
                const parentDom = domRef.get().parentNode;

                let state = "relative";
                const top = 10;

                let cleanup = null;
                let backToRelative = null;

                const listener = () => {
                    const r1 = dom.getBoundingClientRect();
                    const r2 = parentDom.getBoundingClientRect();

                    const usableHeight = (
                        (r2.top + r2.height) -
                        Math.max(top, r2.top)
                    );

                    const newState = (() => {
                        if (r2.top >= top) {
                            return "relative";
                        }

                        if (r1.height < usableHeight) {
                            return "screenTop";
                        }

                        return "parentBottom";
                    })();

                    if (newState !== state) {
                        // console.log("newState", newState);

                        if (state === "relative") {
                            const d1 = document.createElement("div");
                            d1.style.height = r1.height + "px";
                            d1.style.pointerEvents = "none";
                            parentDom.append(d1);
                            backToRelative = () => {
                                d1.remove();
                            };
                        } else if (newState === "relative") {
                            backToRelative?.();
                            backToRelative = null;
                        }

                        cleanup?.();
                        cleanup = null;
                        state = newState;

                        if (newState === "screenTop") {

                            dom.style.position = "fixed";
                            dom.style.top = top + "px";
                            dom.style.width = r1.width + "px";

                            cleanup = () => {
                                dom.style.removeProperty("position");
                                dom.style.removeProperty("top");
                                dom.style.removeProperty("width");
                            };
                        } else if (newState === "parentBottom") {

                            dom.style.position = "absolute";
                            dom.style.bottom = "0px";
                            dom.style.width = r1.width + "px";

                            cleanup = () => {
                                dom.style.removeProperty("position");
                                dom.style.removeProperty("bottom");
                                dom.style.removeProperty("width");
                            };
                        }
                    }

                };
                window.addEventListener("scroll", listener);
                cleanups.push(() => {
                    // cleanup?.();
                    window.removeEventListener("scroll", listener);
                });
            },
        }),
    ),
    ({domRef}) => next({
        domRef: domRef.set,
    }),
);
